import {IData, IFamilyDetailFormModel} from "../types/family-detail.types";
import {FamilyDetail, Gender, Relation_Type} from "../../../../../domains/models/employee";
import server from "../../../../../server";

export function viewMapper(data: IData): IFamilyDetailFormModel {
    return {
        familyDetails: data.family.map(f => ({
            name: f.name,
            mobileNumber: {
                countryCode:f.mobileNumber.countryCode,
                number:f.mobileNumber.number
            },
            relationType: f.relationType,
            gender: f.gender
        }))
    };
}

export function modelMapper(data: IFamilyDetailFormModel): FamilyDetail[] {
    return data.familyDetails.map((item, index) => ({
        name: item.name,
        mobileNumber: {
            countryCode:item.mobileNumber.countryCode,
            number:item.mobileNumber.number
        },
        relationType: item.relationType as Relation_Type,
        gender: item.gender as Gender
    }));
}

export async function fetchData(employeeId: string) {
    const family: FamilyDetail[] = await server.employee.family.get(employeeId);
    return {family};
}
